import { useEffect, useRef } from 'react';
import confetti from 'canvas-confetti';
import posthog from 'posthog-js';
import { showSuccess } from '../lib/toast';

export function useFirstBookingCelebration(userId, totalBookingsCount, firstBooking) {
  const firedRef = useRef(false);

  useEffect(() => {
    if (!userId || totalBookingsCount !== 1 || firedRef.current) return;

    const storageKey = `firstBookingCelebrated_${userId}`;
    if (localStorage.getItem(storageKey)) return;

    // Guard against backgrounded tab
    if (document.visibilityState === 'hidden') return;

    // Set flag immediately to prevent race across tabs
    localStorage.setItem(storageKey, 'true');
    localStorage.setItem(`${storageKey}_at`, String(Date.now()));
    firedRef.current = true;

    posthog.capture('first_booking');

    // Respect prefers-reduced-motion
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!prefersReduced) {
      confetti({
        particleCount: 120,
        spread: 80,
        origin: { y: 0.5 },
        disableForReducedMotion: true,
      });

      setTimeout(() => confetti.reset(), 1500);
    }

    const name = firstBooking?.customer_name ?? 'Someone';
    const date = firstBooking?.start_time
      ? new Date(firstBooking.start_time).toLocaleDateString('en-GB', {
          weekday: 'short',
          day: 'numeric',
          month: 'short',
        })
      : 'soon';

    showSuccess(`Your first booking! ${name} has booked with you on ${date}`, {
      duration: 5000,
    });
  }, [userId, totalBookingsCount]);
}
